import _ from 'lodash'
import { useMemo } from 'react'

import WaitingRoomsTable from '../components/WaitingRoomsTable'
import { useListWaitingRoomsQuery } from '@/core/services/waiting-room'

export function WaitingRoomsTableContainer() {
  const { waitingRooms, isFetching } = useListWaitingRoomsQuery(
    { query: {}, options: { limit: 0, skip: 0 } }, // list all waiting rooms
    { refetchOnMountOrArgChange: true, selectFromResult: ({ data, ...rest }) => ({ ...rest, waitingRooms: data?.items ?? [] }) }
  )

  const data = useMemo(
    () =>
      _.map(waitingRooms, (waitingRoom) => ({
        id: waitingRoom._id,
        isPrioritized: waitingRoom.isPrioritized,
        name: waitingRoom.name,
        price: waitingRoom.price !== 0 ? waitingRoom.price : undefined,
      })),
    [waitingRooms]
  )

  return <WaitingRoomsTable data={data} loading={isFetching} totalCount={waitingRooms.length} />
}

export default WaitingRoomsTableContainer
